import jwt from "jsonwebtoken";

function setAccessToken(accessToken) {
  window.localStorage.setItem("accesstoken", accessToken);
}
function getAccessToken() {
  return window.localStorage.getItem("accesstoken");
}

function setIdToken(idToken) {
  window.localStorage.setItem("idtoken", idToken);
}
function getIdToken() {
  return window.localStorage.getItem("accesstoken");
}

function setRefreshToken(refreshToken) {
  window.localStorage.setItem("refreshtoken", refreshToken);
}
const getRefreshToken = () => {
  return window.localStorage.getItem("refreshtoken");
};

function wrappeUser() {
  if (getIdToken() == null || getAccessToken() == null) return null;

  let _idToken = jwt.decode(getIdToken());
  let _accessToken = jwt.decode(getAccessToken());

  if (_accessToken == null || _idToken == null) return null;

  let email = _accessToken.username
    .replace("adcognitoprovider_", "")
    .replace("cognito_", "")
    .replace("Cognito-login_", "");

  const user = {
    name: _idToken.given_name,
    login: _idToken["custom:accountName"],
    email,
  };

  return user;
}

const handleLogin = (data) => {
  if (!data) {
    removeToken();
    return;
  }

  if (data["access_token"]) setAccessToken(data["access_token"]);

  if (data["id_token"]) setIdToken(data["id_token"]);

  if (data["refresh_token"]) setRefreshToken(data["refresh_token"]);
};

function removeToken() {
  window.localStorage.removeItem("accesstoken");
  window.localStorage.removeItem("idtoken");
  window.localStorage.removeItem("refreshtoken");
  window.localStorage.removeItem("loggedUser");
}

function logout() {
  window.localStorage.removeItem("accesstoken");
}

const current = wrappeUser;

export {
  wrappeUser as default,
  current,
  getRefreshToken,
  getIdToken,
  handleLogin,
  logout,
};
